import React, { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";
import ReactHtmlParser from "react-html-parser";
import { useNavigate, useLocation } from "react-router-dom";

const items = [
  {
    title: "Building Ideas. <br/>Creating Opportunities. <br/>Engineering Better Futures.",
    description: "For over three decades, I’ve had the privilege of building businesses, brands, experiences, and communities. This is where I share the philosophy, lessons, <br class='md:block hidden'/>and opportunities that continue to shape my journey, and the work we’re building for tomorrow.",
    buttonText: "Explore my journey",
    link: "/jovy-rabelas",
    // image: "/image/banner/_about-poster3.jpg",
     image: "/assets/hero/banner.png",
    showNav: false,
  },
  {
    title: "An artist who loves <br/>to elevate spaces",
    description: "Spaces where beauty and modernity meet",
    buttonText: "View JLR’s Spaces",
    link: "https://moodboard.space/",
    image: "/image/banner/_his-works2.jpg",
    showNav: true,
    target: "_blank",
    facebook: "https://www.facebook.com/MoodboardSpace",
    instagram: "https://www.instagram.com/moodboard_space/",
  },
  {
    title:
      "Crossing borders, <br/>Curating experiences, <br/>Cultivating perspectives",
    description:
      "Travel is the origin of inspiration, and JLR is always jet-setting",
    buttonText: "See the world from JLR’s lens",
    // link: "https://worldjuanderer.com/",
    link: "/jlr-travels",
    image: "/image/banner/_travel-poster2.jpg",
    showNav: true,
    // target: "_blank",
    facebook: "https://www.facebook.com/WorldJuanderer",
    instagram: "https://www.instagram.com/worldjuanderer/",
  },
  {
    title: "A palette <br/>for the piquant",
    description: "Discover the pleasures of dishes divine and tastes refined",
    buttonText: "Checkout what’s on JLR’s Plate",
    link: "/jlr-foods",
    image: "/image/banner/_food-poster.jpg",
    showNav: true,
  },
  // {
  //   title: "A trailblazer with <br/>transformative ideas",
  //   description: '',
  //   buttonText: "Contact",
  //   link: "",
  //   image: "/image/banner/_contact-poster3.jpg",
  //   showNav: true,
  // },
  {
    title: "An icon who <br/>turns looks into <br/> statements",
    description:
      "JLR doesn’t just follow fashion, he defines it with every piece he puts on.",
    buttonText: "See His Picks",
    link: "https://shoppersalley.ph/",
    image: "/image/banner/_fashion-poster5.jpg",
    showNav: true,
    target: "_blank",
    facebook: "https://www.facebook.com/GlobalShoppersAlley",
    instagram: "https://www.instagram.com/shoppersalley/",
  },
];

const LandingCarousel = ({ slide }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeIndex, setActiveIndex] = useState(0);

  let currIndex = activeIndex ? activeIndex : 0;

  const prev = () => {
    currIndex--;

    var carouselItems = document.querySelectorAll(".carousel .__carousel-item");
    if (currIndex < 0) {
      currIndex = carouselItems.length - 1;
    }

    loadImage(currIndex);
  };
  const next = () => {
    currIndex++;

    var carouselItems = document.querySelectorAll(".carousel .__carousel-item");
    if (currIndex > carouselItems.length - 1) {
      currIndex = 0;
    }

    if (currIndex < 0) {
      currIndex = carouselItems.length - 1;
    }
    loadImage(currIndex);
  };

  const loadImage = (x) => {
    const image = new Image();
    image.onload = function () {};
    image.src = "";

    switch (x) {
      case 0:
        navigate("/about");
        break;
      case 1:
        navigate("/spaces");
        break;
      case 2:
        navigate("/travel");
        break;
      case 3:
        navigate("/food");
        break;
      case 4:
        navigate("/fashion");
        break;
      // case 4:
      //   navigate('/contact')
      //   break;
      default:
        break;
    }

    setActiveIndex(x);

    setTimeout(() => {}, 0);
  };

  const getActiveIndex = (slug) => {
    switch (slug) {
      case "about":
        return 0;
      case "spaces":
        return 1;
      case "travel":
        return 2;
      case "food":
        return 3;
      case "fashion":
        return 4;
      // case 'contact':
      //   return 4;
      //   break;
      default:
        return 0;
    }
  };

  const toggleAside = () => {
    const aside = document.getElementById("aside");
    aside.classList.toggle("active");
  };

  useEffect(() => {
    const page = location.pathname;
    const slug = page.replace("/", "");

    const active = getActiveIndex(slug);
    setActiveIndex(active);
  }, [location]);

  return (
    <div id="about" className="relative h-full">
      <div className="carousel">
        <div className="__carousel-inner">
          {items.map((e, i) => {
            return (
              <div
                className={`__carousel-item ${
                  activeIndex === i ? "active" : ""
                }`}
                key={i}
              >
                <Fade>
                  <div className="group relative">
                    {/* <div className=""> */}
                    <div className="md:h-[calc(100vh-80px)] h-[calc(100vh-72px)]">
                      {Array.isArray(e.image) && (
                        <Fade
                          cascade={true}
                          triggerOnce={true}
                          direction="up"
                          duration={450}
                          className="custom-image-animation"
                        >
                          {e.image.map((image, index) => {
                            return (
                              <div
                                key={index}
                                className={
                                  index > 0
                                    ? `absolute top-0 w-full h-full`
                                    : ""
                                }
                              >
                                <img
                                  src={image}
                                  alt=""
                                  className="object-cover object-top w-full h-full"
                                />
                              </div>
                            );
                          })}
                        </Fade>
                      )}
                      {/* {!Array.isArray(e.image) && <img className="object-cover object-bottom w-full h-[calc(100vh-72px)]" src={e.image} alt="" />} */}
                      {!Array.isArray(e.image) && (
                        <img
                          className="object-cover object-top w-full h-full"
                          src={e.image}
                          alt=""
                        />
                      )}
                    </div>

                    {i === 0 && (
                      <div
                        className="absolute inset-0 bg-black/40"
                        aria-hidden="true"
                      />
                    )}

                    <div
                      className={`__carousel-content flex absolute top-0 left-0 w-full h-full items-center justify-center flex-col show`}
                    >
                      {/* <div className="md:w-10/12 w-4/5 md:mb-16 mb-4 overflow-hidden"> */}
                      <div
                        className={`md:w-11/12 w-4/5 overflow-hidden ${
                          [2, 4].includes(activeIndex)
                            ? "md:mt-16"
                            : "md:mt-0 md:mb-16 mb-4"
                        }`}
                      >
                        <div className="md:px-5">
                          <h2 className="fade-left title text-white md:text-6xl text-2xl leading-[1.15!important] font-black mb-8">
                            {ReactHtmlParser(e.title)}
                          </h2>

                          <div className="text-white max-w-2xl">
                            {ReactHtmlParser(e.description)}&nbsp;
                          </div>
                          {e.buttonText === "Contact" && (
                            <div className="mt-2">
                              <button
                                onClick={toggleAside}
                                className={`text-white underline font-semibold`}
                                to={e.link}
                              >
                                {e.buttonText}
                              </button>
                            </div>
                          )}
                          {e.buttonText !== "Contact" && (
                            <div className="mt-5">
                              {/* <Link className={`text-white underline font-semibold`} to={e.link}>{e.buttonText}</Link> */}
                              <a
                                className={`text-white underline font-semibold`}
                                href={e.link}
                                target={e.target}
                              >
                                {e.buttonText}
                              </a>
                            </div>
                          )}
                        </div>
                        {e.facebook && e.instagram && (
                          <div className={`__carousel-nav md:px-5 mb-8`}>
                            <div className="__social-fb">
                              <a href={e.facebook} target="_blank" rel="noopener noreferrer">
                                <img src="/fb.png" alt="" />
                              </a>
                            </div>
                            <div className="__social-ig">
                              <a href={e.instagram} target="_blank" rel="noopener noreferrer">
                                <img src="/ig.png" alt="" />
                              </a>
                            </div>
                          </div>
                        )}

                        <div
                          className={`__carousel-nav md:px-5`}
                          style={{ display: !e.showNav ? "none" : "flex" }}
                        >
                          <div className="__prev" onClick={prev}>
                            <span></span>
                          </div>
                          <div className="__next" onClick={next}>
                            <span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fade>
              </div>
            );
          })}
        </div>

        {/* <ol className="__carousel-indicator">
          <li data-slide-to="1"></li>
          <li data-slide-to="2"></li>
          <li data-slide-to="3"></li>
        </ol> */}
      </div>
    </div>
  );
};
export default LandingCarousel;
